import {useEffect,useState} from 'react' 
import ReadSkeletonLoader from './ReadSkeletonLoader'

const Read = ({readVal}) => {
    const [text,setText] = useState('')
    const [title,setTitle] = useState('')
    const [dataStatus, setDataStatus] = useState('')

    useEffect(()=>{
        fetchInfo(readVal)
    },[readVal])

    const fetchInfo = async (value) => {
        const endPoint = "https://en.wikipedia.org/w/api.php?"
        const params = {
            "origin": "*",
            "action": "parse",
            "format": "json",
            "page": value,
            "prop": "text",
            "formatversion": "2"
        }

        const esc = encodeURIComponent
        const query = Object.keys(params).map(k => esc(k) + '=' +esc(params[k])).join('&')
        const url = endPoint + query

        try{
            setDataStatus('loading')
            const res = await fetch(url)
            const data = await res.json()
            setText(data.parse.text)
            setTitle(data.parse.title)
            setDataStatus('complete')
        }catch(err){
            console.log(err)
            alert("Something went wrong")
            setDataStatus('loading')
        }
    }

    return (
        <div  className="read-body">
            {
                dataStatus === 'loading'
                ? 
                <div className="skeleton-loader-cont">
					<div className="skeleton-loader">
						<ReadSkeletonLoader />
						<ReadSkeletonLoader />
						<ReadSkeletonLoader />
						<ReadSkeletonLoader />
					</div>
					<div className="skeleton-shimmer-cont">
					
					</div>
				</div>
                : 
                <div>
                    <div className="read-title">{title}</div>
                    <div className="read-content" dangerouslySetInnerHTML={{__html: text}}></div>
                </div>
            }
            
        </div>
    )
}

export default Read